import type { MyAppStoreAccess } from "@verbleif/lib/src/composables/Api/Type/AppStore/app.interface";
import { iriToId } from "@verbleif/lib/src/composables/Utils/iri.helpers";
import { api } from "../Api/api";

/** `GET /api/clients/{client}/my_app_store_access`: what the signed-in person reaches there through shares. */
export async function fetchMyAppStoreAccess(clientIri: string): Promise<MyAppStoreAccess> {
  const { data } = await api.get<MyAppStoreAccess>(`/api/clients/${iriToId(clientIri)}/my_app_store_access`);

  return data;
}
